import { NotificationsByIdName } from '../name';
import { removeNotificationsById } from '../@sync/remove';
import { SonarNotificationType } from '../../../@types';
import { AMPLITUDE_EVENT, createLogSagaWithFn } from '@sonar-software/sonar-analytics';
import { createDeleteAsyncSlice, DeleteAction, SagaYieldType } from '@sonar-software/xuder';
import { deleteNotificationsById, DeleteNotificationsByIdRequest } from '../../../api/';

type LogDeleteNotificationsByIdRequest = DeleteNotificationsByIdRequest & {
	type: SonarNotificationType;
};

const logDeleteNotificationsByIdAsync = createLogSagaWithFn<
	DeleteAction<typeof NotificationsByIdName, LogDeleteNotificationsByIdRequest>
>((action) => {
	const data = action.data as LogDeleteNotificationsByIdRequest;

	return {
		data: {
			type: data.type
		},
		id: AMPLITUDE_EVENT.NOTIFICATION_DISMISSED
	};
});

export const notificationsByIdDeleteSlice = createDeleteAsyncSlice<
	typeof NotificationsByIdName,
	LogDeleteNotificationsByIdRequest
>({
	additionalRequestSteps: [
		{
			actionHandler: logDeleteNotificationsByIdAsync,
			type: SagaYieldType.Every
		}
	],
	httpSagaOptions: {
		preRequestActionCreators: [ removeNotificationsById.syncActionCreator ]
	},
	name: 'NotificationsById',
	receive: false,
	request: true,
	requestHandler: deleteNotificationsById
});
